import {MediaList} from "../components/ContentBlock/MediaList";
import StoreManager from "./StoreManager";
import Media from "../dataModel/Media";


export default class AudioManager {

    static audio;

    static _lastPlayedSpeek;
    static get lastPlayedSpeek() {
        return this._lastPlayedSpeek;
    }
    static set lastPlayedSpeek(value) {
        this._lastPlayedSpeek = value;
        StoreManager.changeMediaProgress({
            progress: 0,
            duration: 0,
            position: 0
        }).then();
    }

    static get currentMediaNodeText() {
        const speakNode = AudioManager.currentSpeakNode;

        if (speakNode) {
            const textList = speakNode
                .map(s => s.textData || null)
                .filter(t => !!t);

            if (textList.length > 0) {
                return  textList;
            }
        }

        return null;
    }

    static speech;

    static isPaused = false;

    static lastStartedIsAudio = null;


    static play(media) {
        try {
            this._checkInitialisation();
            console.log("play()", media.mediaId);


            if (MediaList.instance.state.isPlaying) {
                if (MediaList.instance.state.playingId === media.mediaId) {
                    AudioManager.pause();
                    console.log("paused", media.mediaId);
                    return
                }
                else {
                    AudioManager.stop();
                    console.log("stopped", media.mediaId);
                }
            }
            else {
                console.log("Checking if should resume playing");
                if (AudioManager.lastPlayedSpeek && AudioManager.isPausedOnThisMediaNode(media)) {
                    // Continue playing ...
                    try {
                        AudioManager.continuePlaying();
                        console.log("resume", media.mediaId);
                        return
                    }
                    catch (e) {
                        console.log("resume throws error!!!");
                        AudioManager.stop()
                    }
                }
            }

            if (!media.isPlayable) {
                console.log("Media isn't playable");
                this.lastPlayedSpeek = media;
                this._playNextAudio();
                return;
            }

            console.log(media);
            this._changePlayingState(true, media.mediaId);
            AudioManager.isPaused = false;

            if (media.fileId) {
                if (!media.fileData) {
                    console.log('Start downloading');
                    StoreManager.downloadSoundtrackData(media.fileId)
                        .then(media => {
                            console.log('Data received');
                            if (MediaList.instance.state.isPlaying && media && MediaList.instance.state.playingId === media.mediaId) {
                                this.lastPlayedSpeek = media;
                                this._startAudio(media.fileData);
                            }
                        });

                    return;
                }

                this.lastPlayedSpeek = media;
                this._startAudio(media.fileData);
                // StoreManager.changePlaying(true);

                return;

            } else if (media.textData) {
                this.lastPlayedSpeek = media;
                this._startSpeech(media.textData, media.language);
                // StoreManager.changePlaying(true);

                return;
            }

        } catch (e) {
            console.log(e);
        }
    };

    static isPausedOnThisMediaNode(media) {
        // if was paused on this media or it parent
        return (AudioManager.isPaused && (AudioManager.lastPlayedSpeek.mediaId === media.mediaId || AudioManager.lastPlayedSpeek.parent.mediaId === media.mediaId))
    }

    static pause() {
        this._changePlayingState(false);
        AudioManager.isPaused = true;

        try {
            if (AudioManager.lastStartedIsAudio === false) {
                window.speechSynthesis.pause();
            }

            if (AudioManager.lastStartedIsAudio) {
                AudioManager.audio.pause();

                window.speechSynthesis.cancel();
                AudioManager.speech.onend = () => {
                };
            }

        } catch (e) {
            console.error(e);
            AudioManager.stop();
        }

    }

    static continuePlaying() {
        // MediaList.instance.isPlaying(true);

        try {
            this._changePlayingState(true, AudioManager.lastPlayedSpeek.mediaId);

            if (!AudioManager.isPaused) {
                AudioManager.stop();

                AudioManager.lastPlayedSpeek = null;
                // AudioManager.play(AudioManager.lastPlayedSpeek);
                return
            }

            AudioManager.isPaused = false;

            if (window.speechSynthesis && window.speechSynthesis.paused && AudioManager.lastStartedIsAudio === false) window.speechSynthesis.resume();
            if (AudioManager.audio.paused && AudioManager.audio.currentTime > 0 && AudioManager.lastStartedIsAudio) AudioManager.audio.play();
        } catch (e) {
            AudioManager.stop();
            console.error("Continue playing throws error:", e)
        }

    }

    static stop() {

        this._changePlayingState(false)
        AudioManager.isPaused = false;

        try {
            if (AudioManager.speech) AudioManager.speech.onend = ()=>{};
            if (window.speechSynthesis) window.speechSynthesis.cancel();

            if (AudioManager.audio) {
                AudioManager.audio.pause();
                AudioManager.audio.currentTime = 0;
            }

        } catch (e) {console.error(e)}

    }


    static startNextTrack() {
        this.stop();
        this._playNextAudio();
    }

    static startPreviousTrack() {
        if (!this.lastPlayedSpeek) return;
        const currentSpeakNode = this.currentSpeakNode;

        const currentIndex = currentSpeakNode.findIndex(it => it.mediaId === this.lastPlayedSpeek.mediaId);

        if (currentIndex < 0) return;
        if (currentIndex === 0) {
            this.stop();
            return;
        }

        const prevSpeek = currentSpeakNode[currentIndex - 1];
        if (!prevSpeek) return;

        this.play(prevSpeek);
    }

    static changeAudioPosition(value) {
        if (!this.lastPlayedSpeek) return;

        if (this.lastStartedIsAudio && this.audio.duration > 0) {
            this.audio.currentTime = (this.audio.duration / 100) * value
        }
        else {
            // this.speech.text = this.lastPlayedSpeek.textData
        }
    }

    // returns main soundtrack and children
    static get currentSpeakNode() {
        if (!this.lastPlayedSpeek) {
            return null
        }

        const track = this.lastPlayedSpeek.isSubTrack ? this.lastPlayedSpeek.parent : this.lastPlayedSpeek;
        const children = Media.sortByPrefPrevTag(track.parent.mediaEntries.filter(item => item.isSpeak && item.isChildOf(track)));

        return [track, ...children]
    }


    static _onAudioProgress() {
        const progress = this.audio.duration
            ?  Math.round((this.audio.currentTime / this.audio.duration) * 100)
            : 0;

        StoreManager.changeMediaProgress({progress, duration: this.audio.duration || 0, position: this.audio.currentTime || 0})
            .then()
    }

    static _onSpeechProgress(charIndex, length, elapsedTime) {
        const position = elapsedTime ? elapsedTime / 1000 : null;

        const secPerSymbol = position ? position / (charIndex || 1) : null;
        const duration = secPerSymbol ? length * secPerSymbol : this._lastSpeechDuration || null;

        if (duration) this._lastSpeechDuration = duration;

        const progress = length
            ?  Math.round((charIndex / length) * 100)
            : 0;

        StoreManager.changeMediaProgress({progress, duration, position: position || duration || 0})
            .then()
    }


    static _checkInitialisation() {
        if (!this.audio) {
            this.audio = new Audio();

            this.audio.addEventListener("timeupdate", () => this._onAudioProgress());
            this.audio.addEventListener('error', (e) => {
                console.error(e);

                this.stop();
                this.audio = null;
                this._checkInitialisation();
                this.play(this.lastPlayedSpeek);
            }, true);

            this.audio.onended = () => this._playNextAudio();
        }

        if (!this.speech && window.SpeechSynthesisUtterance) {
            this.speech = new window.SpeechSynthesisUtterance();

            this.speech.onboundary = (e) => {
                this._onSpeechProgress(e.charIndex, this.speech.text.length, e.elapsedTime);
            }
        }
    }

    static _playNextAudio() {
        console.log('_playNext');

        const media = this.lastPlayedSpeek;
        if (!media) return;

        // AudioManager.stop();

        if (media.isSubTrack) {
            // console.log('PLAY next sub');

            let ownPosition = -1;

            let list = Media.sortByPrefPrevTag(media.parent.parent.mediaEntries.filter(it => {
                return it.isAllowedForWeb && it.isChildOf(media.parent)
            }));

            // console.log("list audio",list.map((i) => i.getDescription))
            // let list = this.currentSpeakNode;
            if (list.length < 1) {
                this._changePlayingState(false);
                return;
            }

            list.forEach((it, i) => {
                if (it.mediaId === media.mediaId) ownPosition = i;
                if (ownPosition > -1 && i - ownPosition === 1) this.play(it);
            });

            if (ownPosition + 1 === list.length) {
                this._changePlayingState(false);
            }

        } else {
            // console.log('PLAY first sub');

            let list = Media.sortByPrefPrevTag(media.parent.mediaEntries.filter(it => {
                return it.isAllowedForWeb && it.isChildOf(media);
            }));

            console.log("list audio", list.map((i) => `${i.getDescription}(${i.mediaId}, ${i.tags.PrefPrevSpeakId})`))
            // let list = this.currentSpeakNode;
            if (list.length < 1) {
                this._changePlayingState(false);
                return;
            }
            // console.log(list);
            this.play(list[0]);

        }

    }

    static loadDataFromLastSpeek() {

        const base64Audio = this.lastPlayedSpeek.fileData;
        const text = this.lastPlayedSpeek.textData;

        if (base64Audio && this.audio) {
            this.stop();
            this.audio.src = base64Audio.includes('base64,') ? base64Audio : "data:audio/wav;base64," + base64Audio;
            this.lastStartedIsAudio = true;
        } else if (text && this.speech) {
            this.stop();
            this.speech.text = text;
            this.lastStartedIsAudio = false;
        }


    }

    static _startAudio(base64Audio) {
        AudioManager.audio.src = base64Audio.includes('base64,') ? base64Audio : "data:audio/wav;base64," + base64Audio;
        AudioManager.lastStartedIsAudio = true;

        AudioManager.audio.play();
    }

    static _startSpeech(text, language) {
        if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) {
            this.stop();
            alert("Your device doesn't support speech synthesis");
            return;
        }

        const voices = window.speechSynthesis.getVoices();
        AudioManager.speech.text = text;
        AudioManager.lastStartedIsAudio = false;

        if (voices.length === 0) {
            AudioManager.speech.lang = language;
        } else {
            const targetVoice = voices.find(it => it.lang.toLowerCase().includes(language));
            if (targetVoice) AudioManager.speech.voice = targetVoice;
            // console.log(targetVoice);
        }

        // AudioManager.speech.onend = () => this._playNextAudio();
        this.speech.onend = () => {
            this._onSpeechProgress(this.speech.text.length, this.speech.text.length, null);
            this._playNextAudio();
        };

        window.speechSynthesis.speak(AudioManager.speech);
    }

    static _changePlayingState(val = false, id = null) {
        MediaList.instance
            && MediaList.instance.isPlaying(val, id);
        StoreManager.changePlaying(val);
    }

}
